import { Reveal } from "../Reveal";

const PARAGRAPHS = [
  "Born in Sydney and raised in Madrid, JAY began tattooing in the Spanish capital in 2017. Entirely self-taught, he emerged during the early rise of Fine Line tattooing in Spain, developing the precision and technical foundation that would later define his distinctive approach to Micro Realism.",
  "His work gained international recognition, including features in ELLE and Vogue, before evolving into a signature style influenced by Renaissance and Baroque art, classical sculpture, mythology and architecture. Today, JAY combines Fine Line precision with detailed black & grey realism, translating classical art into contemporary tattoo compositions designed around the body.",
  "His career has taken him across Europe, the United States and Australia, including Madrid, London, Paris, Rome, New York, Miami and Sydney. His work has also earned 1st Place for Best Fine Line & Micro Realism in Sydney in 2024, and another 1st Place award in Madrid in 2025.",
  "Today, JAY is based in Paddington, Sydney, where he is founder and resident artist of JAY-INK Academy, specialising in custom Micro Realism and larger-scale projects while continuing to work internationally.",
  "Through his work and JAY-INK Academy, his vision is clear: to elevate the way contemporary tattooing is perceived and presented, bringing it closer to the world of art it has always belonged to.",
];

export default function FounderStory() {
  return (
    <section
      id="founder-story"
      data-testid="founder-story-section"
      className="relative overflow-hidden bg-white py-28 md:py-40 px-6 md:px-12"
    >
      {/* Logo watermark background */}
      <div className="absolute inset-0 pointer-events-none">
        <img
          src="/jay-ink-logo.png"
          alt=""
          aria-hidden
          draggable={false}
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 max-w-none object-cover select-none"
          style={{ width: "max(100vw, 100vh)", height: "max(100vw, 100vh)" }}
        />
      </div>
      {/* Soft white veil for legibility */}
      <div className="absolute inset-0 bg-white/78 pointer-events-none" />

      <div className="relative z-10 max-w-3xl mx-auto">
        <Reveal delay={0.05}>
          <div className="overline mb-10 text-[#666] text-center">— The Founder</div>
        </Reveal>
        <div className="space-y-6 md:space-y-8">
          {PARAGRAPHS.map((p, i) => (
            <Reveal key={i} delay={0.12 + i * 0.05}>
              <p className="text-sm md:text-base text-[#333] leading-relaxed font-light">
                {p}
              </p>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.18}>
          <div className="mt-10 md:mt-12 text-center">
            <a
              href="https://www.instagram.com/jayink__/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="founder-story-instagram"
              className="inline-block text-[10px] md:text-xs tracking-[0.3em] uppercase text-[#0A0A0A] border-b border-[#0A0A0A] pb-1 hover:opacity-60 transition-opacity"
            >
              @jayink__
            </a>
          </div>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-10 md:mt-12 text-center">
            <a
              href="/portfolio/jay"
              data-testid="founder-story-view-work"
              className="inline-block text-[10px] md:text-xs tracking-[0.28em] uppercase px-8 py-3 border border-[#0A0A0A] text-[#0A0A0A] hover:bg-[#0A0A0A] hover:text-white transition-colors"
            >
              View Work →
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
